export type OAuthClient = {
    id: string;
    name: string;
    clientId: string;
    clientSecretMask: string;
    scopes: OAuthScope[];
    createdAt: Date;
    createdBy: number;
    updatedAt: Date;
    updatedBy: number;
}

export type CreateOAuthClientRequest = {
    readonly name: string;
    readonly scopes: OAuthScope[];
};

export type RegenerateSecretResponse = OAuthClient & {
    readonly clientSecret: string;
};

export enum OAuthScope {
    AppointmentsRead = 'appointments:read',
    AppointmentsCreate = 'appointments:create',
    AppointmentsUpdate = 'appointments:update',
    AppointmentsDelete = 'appointments:delete',
    ClientConnectionsRead = 'client-connections:read',
    ClientConnectionsCreate = 'client-connections:create',
    ClientConnectionsUpdate = 'client-connections:update',
    ClientConnectionsDelete = 'client-connections:delete',
    ClientConnectionsNotify = 'client-connections:notify',
    SessionsOnlineSummary = 'sessions:online:summary',
    SessionsParticipantUpdate = 'sessions:participant:update',
    UsersAvailability = 'users:availability',
    SettingsUserInfoSchemaRead = 'settings:user-info-schema:read',
}

